<template>
  <az-container>
    <az-form>
      <div class="li-tabela mb-5 pb-5">
        <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                      :pagination.sync="paginacaoInterna"
                      no-data-text="Nenhum termo encontrado"
                      class="az-table-list tabela-termos" hide-actions>
          <template slot="items" slot-scope="props">
            <td style="padding: 10px !important;">{{ props.item.descricao }}</td>
            <td v-if="props.item.tipo" style="padding: 10px !important;">{{ props.item.tipo | azEnum(tiposTermoAceite) }}</td>
            <td v-else style="padding: 10px !important;">-</td>
            <td style="padding: 10px !important;">{{ props.item.impeditivo ? 'Sim' : 'Não' }}</td>
            <td style="padding: 10px !important;">{{ props.item.situacao | azEnum(situacoesAtivoInativo) }}</td>
            <td class="table-actions">

              <v-tooltip top class="no-mobile" v-az-auth="'DeclaracoesTermos.Visualizar'">
                <a style="margin: 2px !important;" slot="activator" @click="$emit('visualizar', props.item.id)">
                  <v-icon style="">search</v-icon>
                </a>
                Visualizar
              </v-tooltip>

              <v-tooltip top v-if="props.item.situacao === 'ATIVO'"
                         v-az-auth="'DeclaracoesTermos.Atualizar'">
                <a slot="activator" style="margin: 2px !important;"
                   :class="naoPodeAlterarItem(props.item.id) ? 'desativado' : '' "
                   @click.prevent="emitirInativarTermo(props.item)" title="Inativar Anexo">
                  <v-icon>visibility_off</v-icon>
                </a>
                <span v-if="naoPodeAlterarItem(props.item.id)">Aguarde</span>
                <span v-else>Inativar</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.situacao === 'INATIVO'"
                         v-az-auth="'DeclaracoesTermos.Atualizar'">
                <a slot="activator" style="margin: 2px !important;"
                   :class="naoPodeAlterarItem(props.item.id) ? 'desativado' : '' "
                   @click.prevent="emitirAtivarTermo(props.item)" title="Ativar Anexo">
                  <v-icon>visibility</v-icon>
                </a>
                <span v-if="naoPodeAlterarItem(props.item.id)">Aguarde</span>
                <span v-else>Ativar</span>
              </v-tooltip>
              <v-tooltip top class="no-mobile" v-az-auth="'DeclaracoesTermos.Atualizar'">
                <a slot="activator" style="margin: 2px !important;"
                   @click="$emit('editar',props.item.id)">
                  <v-icon>edit</v-icon>
                </a>
                Editar
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <div class="az-pagination">
          <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
          <div class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
          </div>
        </div>
      </div>
    </az-form>
  </az-container>
</template>

<script>
import {situacoesAtivoInativo, tiposTermoAceite} from '@/commons/constants'
export default {
  name: "TermosConfiguracaoTabela",
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      situacoesAtivoInativo,
      tiposTermoAceite,
      paginacaoInterna: this.paginacao,
      linhasPorPagina: [5, 10, 25, 50, 100],
      termosBloqueadosTemporario: [],
      colunas: [
        {
          text: 'Descrição',
          align: 'left',
          sortable: false,
          width: '65%',
          class: 'primary--text'
        },
        {
          text: 'Tipo',
          align: 'left',
          sortable: false,
          width: '5%',
          class: 'primary--text'
        },
        {
          text: 'Impeditivo',
          align: 'left',
          sortable: false,
          width: '10%',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          align: 'left',
          sortable: false,
          width: '5%',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '12%',
          class: 'primary--text'
        }
      ]
    }
  },
  methods:{
    bloquearTemporarioAlteracaoTermo(anexoId){
      this.termosBloqueadosTemporario.push(anexoId)
      setTimeout(() => {
        this.termosBloqueadosTemporario.shift()
      }, 5000)
    },
    emitirInativarTermo(termo){
      this.bloquearTemporarioAlteracaoTermo(termo.id)
      this.$emit('inativar', termo.id)
    },
    emitirAtivarTermo(termo){
      this.bloquearTemporarioAlteracaoTermo(termo.id)
      this.$emit('ativar', termo.id)
    },
    naoPodeAlterarItem(termoId){
      return this.termosBloqueadosTemporario.includes(termoId)
    }
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.desativado
  pointer-events none

  i
    opacity 0.5

@media (max-width: 720px)
  .tabela-termos
    td:nth-of-type(1):before
      content: "Descrição:"

    .table-actions
      display none !important
</style>
